import { useState, useCallback } from 'react'

const usePanel = panelName => {
  const [panel, setPanel] = useState(panelName)
  const [properties, setProperties] = useState({})
  const renderPanel = useCallback((name, props) => {
    if (props) {
      setProperties(prevProperties => ({ ...prevProperties, ...props }))
    }

    setPanel(name)
  }, [])

  return {
    panel,
    setPanel,
    renderPanel,
    properties,
    setProperties
  }
}

export { usePanel }
